import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/RubricsGetStarted/desktop';
import Mobile from 'pages/RubricsGetStarted/mobile';
import Tablet from 'pages/RubricsGetStarted/tablet';

const PageLayout = () => {
    const { device } = useViewport();

    const props = {};

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return renderResponsiveLayout(device);
};

export default PageLayout;
